export default "__VITE_ASSET__DcHeTdLP__"